import React from 'react';
import './CheckoutDelivery.css';
import { Utils } from '../../Utils';
import i18n from '../../i18n/i18n.js';
import GlsDpm from '../GlsDpm/GlsDpm.js';
import PacketaDpm from '../PacketaDpm/PacketaDpm.js';

class CheckoutDelivery extends React.Component {
  
  state = {
    selectedDeliveryMethod: null,
    expandedMethods: {}, // Mely elemek vannak kinyitva
    glsMapData: null, // GLS csomagpont választó térkép adatai
    packetaMapData: null, // Packeta csomagpont választó adatai
  };

  errorRef = React.createRef();

  /**
   * GLS adatok visszatöltése a formData-ból
   */
  loadGlsDataFromFormData(formData) {
    if (formData && formData.select_gls_pcl_shop_id) {
      return {
        select_gls_pcl_shop_id: formData.select_gls_pcl_shop_id || '',
        select_gls_shop_code: formData.select_gls_shop_code || formData.select_gls_pcl_shop_id || '',
        select_gls_pcl_shop_name: formData.select_gls_pcl_shop_name || '',
        select_gls_pcl_shop_zipcode: formData.select_gls_pcl_shop_zipcode || '',
        select_gls_pcl_shop_city: formData.select_gls_pcl_shop_city || '',
        select_gls_pcl_shop_address: formData.select_gls_pcl_shop_address || '',
        select_gls_pcl_shop_email: formData.select_gls_pcl_shop_email || '',
        select_gls_pcl_shop_phone: formData.select_gls_pcl_shop_phone || '',
      };
    }
    return null;
  }

  /**
   * Packeta adatok visszatöltése a formData-ból
   */
  loadPacketaDataFromFormData(formData) {
    if (formData && formData.packeta_point_id) {
      return {
        packeta_point_id: formData.packeta_point_id || '',
        packeta_point_address: formData.packeta_point_address || '',
      };
    }
    return null;
  }

  componentDidMount() {
    // Inicializáljuk az értékeket a formData-ból ha vannak
    const { formData } = this.props;

    if (formData && formData.delivery_method_id) {
      const newState = { 
        selectedDeliveryMethod: formData.delivery_method_id,
        expandedMethods: { [formData.delivery_method_id]: true } // Kiválasztott elem automatikusan nyitva
      };

      // GLS csomagpont adatok visszatöltése
      const glsData = this.loadGlsDataFromFormData(formData);
      if (glsData) {
        newState.glsMapData = glsData;
      }

      // Packeta csomagpont adatok visszatöltése
      const packetaData = this.loadPacketaDataFromFormData(formData);
      if (packetaData) {
        newState.packetaMapData = packetaData;
      }

      this.setState(newState);
    }
  }

  componentDidUpdate(prevProps) {
    // Ha a formData megváltozott és van benne delivery_method_id, frissítjük a state-et
    const { formData, formErrors } = this.props;
    
    const deliveryMethodChanged = formData && formData.delivery_method_id !== prevProps.formData?.delivery_method_id;
    const glsShopIdChanged = formData?.select_gls_pcl_shop_id !== prevProps.formData?.select_gls_pcl_shop_id;
    const packetaPointIdChanged = formData?.packeta_point_id !== prevProps.formData?.packeta_point_id;
    
    if (deliveryMethodChanged) {
      const newState = { 
        selectedDeliveryMethod: formData.delivery_method_id,
        expandedMethods: { ...this.state.expandedMethods, [formData.delivery_method_id]: true }
      };

      // GLS csomagpont adatok visszatöltése
      const glsData = this.loadGlsDataFromFormData(formData);
      if (glsData) {
        newState.glsMapData = glsData;
      }

      // Packeta csomagpont adatok visszatöltése
      const packetaData = this.loadPacketaDataFromFormData(formData);
      if (packetaData) {
        newState.packetaMapData = packetaData;
      }

      this.setState(newState);
    }
    // Ha csak a GLS csomagpont változott (de a delivery method ugyanaz)
    else if (glsShopIdChanged && formData.select_gls_pcl_shop_id) {
      const glsData = this.loadGlsDataFromFormData(formData);
      if (glsData) {
        this.setState({ glsMapData: glsData });
      }
    }
    // Ha csak a Packeta csomagpont változott (de a delivery method ugyanaz)
    else if (packetaPointIdChanged && formData.packeta_point_id) {
      const packetaData = this.loadPacketaDataFromFormData(formData);
      if (packetaData) {
        this.setState({ packetaMapData: packetaData });
      }
    }

    // Ha megjelent egy hiba, görgessünk hozzá
    const hasError = formErrors && (formErrors.delivery_method_id || formErrors.delivery_method);
    const hadError = prevProps.formErrors && (prevProps.formErrors.delivery_method_id || prevProps.formErrors.delivery_method);
    
    if (hasError && !hadError && this.errorRef.current) {
      setTimeout(() => {
        this.errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }
  }

  /**
   * KÖTELEZŐ metódus - ezt hívja meg a Form komponens az elküldéskor
   */
  getFormData() {
    const deliveryMethods = this.getDeliveryMethods();
    const selectedMethod = deliveryMethods[this.state.selectedDeliveryMethod];
    
    const formData = {
      delivery_method_id: this.state.selectedDeliveryMethod,
      delivery_method_type: selectedMethod?.delivery_method_type || null
    };

    // Ha van GLS térkép adat, azt is hozzáadjuk
    if (this.state.glsMapData) {
      Object.assign(formData, this.state.glsMapData);
    }

    // Ha van Packeta térkép adat, azt is hozzáadjuk
    if (this.state.packetaMapData) {
      Object.assign(formData, this.state.packetaMapData);
    }

    return formData;
  }

  /**
   * GLS térkép változás kezelése
   */
  handleGlsSelectionChange = (mapData) => {
    this.setState({ glsMapData: mapData });
  }

  /**
   * Packeta térkép változás kezelése
   */
  handlePacketaSelectionChange = (mapData) => {
    this.setState({ packetaMapData: mapData });
  }

  handleDeliveryMethodChange = (methodId) => {
    this.setState({ 
      selectedDeliveryMethod: methodId,
      expandedMethods: { ...this.state.expandedMethods, [methodId]: true }
    });
  }

  toggleMethodExpanded = (methodId) => {
    this.setState(prevState => ({
      expandedMethods: {
        ...prevState.expandedMethods,
        [methodId]: !prevState.expandedMethods[methodId]
      }
    }));
  }

  getDeliveryMethods = () => {
    const { fullFormResponse } = this.props;
    
    if (!fullFormResponse || !fullFormResponse.payment_delivery_methods || !fullFormResponse.payment_delivery_methods.delivery_methods) {
      return {};
    }
    
    return fullFormResponse.payment_delivery_methods.delivery_methods;
  }

  formatDeliveryPrice = (method) => {
    const { appRef } = this.props;
    
    if (!method) return '';
    
    // Ha a method.free flag true, akkor ingyenes
    if (method.free) {
      return i18n.t('checkoutDeliveryFree');
    }
    
    // Különben formázzuk az árat
    let costs = method.cost_gross;

    if(method.logistic_cost_gross){
      costs = costs - method.logistic_cost_gross;
    }
    
    if (costs && costs !== '0' && costs !== 0) {
      return appRef?.current ? Utils.format_currency(costs, appRef.current.currency_settings) : method.delivery_costs;
    }
    
    return i18n.t('checkoutDeliveryFree');
  }

  render() {
    const { blockData, formData, formErrors, summaryMode, onOpenEditor, fullFormResponse, appRef } = this.props;
    const { selectedDeliveryMethod, expandedMethods, glsMapData, packetaMapData } = this.state;
    
    const deliveryMethods = this.getDeliveryMethods();

    if (summaryMode) {
      // Summary nézet
      const hasSelectedMethod = selectedDeliveryMethod && selectedDeliveryMethod !== null;
      const hasError = formErrors && (formErrors.delivery_method_id || formErrors.delivery_method);
      const buttonText = hasSelectedMethod ? i18n.t('checkoutDeliveryEdit') : i18n.t('checkoutDeliverySelect');
      
      // Kiválasztott módszer neve és ára
      let selectedMethodName = '';
      let selectedMethodPrice = '';
      let isGlsPackagePoint = false;
      let isPacketaPackagePoint = false;
      if (hasSelectedMethod && deliveryMethods && deliveryMethods[selectedDeliveryMethod]) {
        selectedMethodName = deliveryMethods[selectedDeliveryMethod].delivery_method || '';
        selectedMethodPrice = this.formatDeliveryPrice(deliveryMethods[selectedDeliveryMethod]);
        isGlsPackagePoint = deliveryMethods[selectedDeliveryMethod].delivery_method_type === 'gls_package_point';
        isPacketaPackagePoint = deliveryMethods[selectedDeliveryMethod].delivery_method_type === 'packeta_package_point';
      }
      
      return (
        <div className={`checkout_delivery_summary ${hasError ? 'has_error' : ''}`}>
          <div className="block_header">
            <h3 className="block_title">{blockData.label ? blockData.label.replace(/<[^>]*>/g, '') : 'Kiszállítás'}</h3>
          </div>
          {hasError && (
            <div className="block_summary_error">
              {formErrors.delivery_method_id && (
                <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.delivery_method_id}}></div>
              )}
              {formErrors.delivery_method && (
                <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.delivery_method}}></div>
              )}
            </div>
          )}
          {hasSelectedMethod && (
            <div className="summary_content">
              <p>{selectedMethodName}</p>
              <p>{selectedMethodPrice}</p>
              {isGlsPackagePoint && glsMapData && glsMapData.select_gls_pcl_shop_name && (
                <div className="gls_summary_info">
                  <p><strong>{glsMapData.select_gls_pcl_shop_name}</strong></p>
                  <p>
                    {glsMapData.select_gls_pcl_shop_zipcode} {glsMapData.select_gls_pcl_shop_city}
                    {glsMapData.select_gls_pcl_shop_address && `, ${glsMapData.select_gls_pcl_shop_address}`}
                  </p>
                  {glsMapData.select_gls_pcl_shop_phone && (
                    <p>{glsMapData.select_gls_pcl_shop_phone}</p>
                  )}
                  {glsMapData.select_gls_pcl_shop_email && (
                    <p>{glsMapData.select_gls_pcl_shop_email}</p>
                  )}
                </div>
              )}
              {isPacketaPackagePoint && packetaMapData && packetaMapData.packeta_point_address && (
                <div className="packeta_summary_info">
                  <p><strong>{packetaMapData.packeta_point_address}</strong></p>
                </div>
              )}
            </div>
          )}
          <button type="button" className="select_button" onClick={onOpenEditor}>{buttonText}</button>
        </div>
      );
    }

    // Normál/Edit nézet
    const hasError = formErrors && (formErrors.delivery_method_id || formErrors.delivery_method);
    const hasSelectedMethod = selectedDeliveryMethod && selectedDeliveryMethod !== null;
    
    return (
      <div className="checkout_delivery_block">
        {/* Ha nincs kiválasztott elem, a hiba a lista tetején */}
          {hasError && !hasSelectedMethod && (
            <div className="form_error" ref={this.errorRef}>
              {formErrors.delivery_method_id && (
                <div dangerouslySetInnerHTML={{__html: formErrors.delivery_method_id}}></div>
              )}
              {formErrors.delivery_method && (
                <div dangerouslySetInnerHTML={{__html: formErrors.delivery_method}}></div>
              )}
            </div>
          )}

        <div className="delivery_methods">
          
          {deliveryMethods && Object.keys(deliveryMethods).length > 0 ? (
            <div className="delivery_methods_list">
              {Object.keys(deliveryMethods).map(methodId => {
                const method = deliveryMethods[methodId];
                const isSelected = selectedDeliveryMethod === methodId;
                const isExpanded = expandedMethods[methodId] || false;

                if(!method['selectable']){
                  return false;
                }
                
                return (
                  <div key={methodId} className={`delivery_method_item ${isSelected ? 'selected' : ''}`}>
                    <div className="delivery_method_header">
                      <input
                        type="radio"
                        name="delivery_method_id"
                        value={methodId}
                        checked={isSelected}
                        onChange={() => this.handleDeliveryMethodChange(methodId)}
                      />
                      <label className="method_info" onClick={() => this.handleDeliveryMethodChange(methodId)}>
                        <div className="method_name">{method.delivery_method || ''}</div>
                        <div className="method_price">{this.formatDeliveryPrice(method)}</div>
                      </label>
                      <div 
                        className={`chevron_icon ${isExpanded ? 'expanded' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          this.toggleMethodExpanded(methodId);
                        }}
                      >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                    
                    {/* Ha ez a kiválasztott elem, a hiba itt jelenik meg */}
                    {hasError && isSelected && (
                      <div className="form_error" ref={this.errorRef}>
                        {formErrors.delivery_method_id && (
                          <div dangerouslySetInnerHTML={{__html: formErrors.delivery_method_id}}></div>
                        )}
                        {formErrors.delivery_method && (
                          <div dangerouslySetInnerHTML={{__html: formErrors.delivery_method}}></div>
                        )}
                      </div>
                    )}

                    {isExpanded && method.delivery_content && (
                      <div className="method_description" dangerouslySetInnerHTML={{ __html: method.delivery_content }} />
                    )}
                    
                    {/* Csak akkor jelenik meg a csomagpont választó, ha ez a módszer van kiválasztva */}
                    {isSelected && (
                      <>
                       {method.delivery_method_type == "gls_package_point" && (
                         <GlsDpm 
                           appRef={appRef} 
                           fullFormResponse={fullFormResponse}
                           onSelectionChange={this.handleGlsSelectionChange}
                           initialData={glsMapData}
                         />
                       )}
                       {method.delivery_method_type == "packeta_package_point" && (
                         <PacketaDpm 
                           appRef={appRef} 
                           fullFormResponse={fullFormResponse}
                           onSelectionChange={this.handlePacketaSelectionChange}
                           initialData={packetaMapData}
                         />
                       )}
                      </>
                    )}
                    
                    
                  </div>
                );
              })}
            </div>
          ) : (
            <p>{i18n.t('checkoutDeliveryNoMethods')}</p>
          )}
        </div>
      </div>
    );
  }
}

export default CheckoutDelivery;